(ns frontend.ux-overhaul.listing.other-asset.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.menu-actions :as menu-actions]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [frontend.ux-overhaul.listing.other-asset.event :as other-asset-event]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "other-asset-listing")

(defn- open-other-asset!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/other-asset})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/other-asset
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :other-asset
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-other-asset
                                 :label    (loc/tr :other-asset-add-button)
                                 :visible? true
                                 :enabled? true
                                 :event    [::other-asset-event/create-other-asset]}
                                {:id                  :bulk-edit-other-assets
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::other-asset-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-other-assets
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::other-asset-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-other-assets
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::other-asset-event/export-grid {:listing-id listing-id}]}
                                {:id       :export-other-assets-with-persons
                                 :label    (loc/tr :save-as-excel-all-data)
                                 :visible? true
                                 :enabled? true
                                 :event    [::other-asset-event/export-grid-with-persons {:listing-id listing-id}]}
                                (menu-actions/field-requirements-action {:entity-type :entity.type/other-asset})]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :other-assets)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.other-asset/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::other-asset-event/create-other-asset])
         :on-row-clicked           open-other-asset!
         :on-card-clicked          open-other-asset!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/other-asset}]
       [menu-actions/field-requirements-modal]])}))
